export const isPreorderAllowedSelector = state => state.customStore.isPreorderAllowed;